import { usePopup } from '@contexts/popupContext';
import { Flap } from '@models/Flap';
import styles from '@styles/components/General/TabScreen.module.css';
import React from 'react';
import { Navigate } from 'react-router-dom';
import ResultPopup from './ResultPopup';
import { LockRounded } from '@mui/icons-material';
import {LiteVersionPopup} from './ProhibitedPopups';

interface TabScreenProps {
    title: string;
    subtitle?: string;
    flaps: Flap[];
    clickedScreen: string;
    setClickedScreen: (screen: string) => void;
}

const TabScreen: React.FC<TabScreenProps> = ({ title, subtitle, flaps, clickedScreen, setClickedScreen }) => {
    const { showPopup } = usePopup();
    
    return (
        <div className={styles['content-block']}>
            <div className={styles['header-container']}>
                <div className={styles['title-container']}>
                    <h2 className={styles['title']}>
                        {title}
                        {subtitle && <p className={styles['sub-title']}>{subtitle}</p>}
                    </h2>
                </div>
            </div>
            <div className={styles['content-container']}>
                <div className={styles['flaps-container']}>
                    {flaps.map((flap) => {
                        return (
                            <div
                                key={flap.id}
                                className={`${styles['flap']} ${clickedScreen === flap.id ? styles['clicked'] : ''} ${flap.isLocked ? styles['locked'] : ''}`}
                                style={flap.width ? { width: flap.width } : undefined}
                                onClick={() => {
                                    if (flap.isLocked) {
                                        showPopup(() => <LiteVersionPopup />);
                                        return;
                                    }
                                    setClickedScreen(flap.id)
                                }}
                            >
                                {flap.label}
                                {flap.isLocked && <LockRounded style={{position: 'absolute', right: '15px', aspectRatio: 1, width: '20px'}}/>}
                            </div>
                        )}
                    )}
                </div>
                <div className={styles['inner-container']} style={{ zIndex: 1 }}>
                    {flaps.find(flap => flap.id === clickedScreen)?.content}
                </div>
            </div>
        </div>
    );
};

interface TabScreenWrapperProps extends TabScreenProps { 
    flag: any;
}

const TabScreenWrapper: React.FC<TabScreenWrapperProps> = ({ title, subtitle, flaps, flag, clickedScreen, setClickedScreen }) => {
    if (!flag) {
        return <Navigate to="/" />;
    }

    return <TabScreen title={title} subtitle={subtitle} flaps={flaps} clickedScreen={clickedScreen} setClickedScreen={setClickedScreen} />;
};

export { TabScreenWrapper };
